var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Person / User / user--avatar--filled--alt / 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Patient-List",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill",
    transform: "translate(-1.000000, -1.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,4 C6.61928813,4 5.5,5.11928813 5.5,6.5 C5.5,7.88071187 6.61928813,9 8,9 C9.38071187,9 10.5,7.88071187 10.5,6.5 C10.5,5.83695878 10.2366079,5.20107399 9.76776695,4.73223305 C9.29892601,4.2633921 8.66304122,4 8,4 Z M8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 C11.8659932,15 15,11.8659932 15,8 C14.9956464,4.13581153 11.8641885,1.00435365 8,1 Z M11.99625,12.4629 C11.9755695,11.0983392 10.8647156,10.0023263 9.5,10 L6.5,10 C5.13528445,10.0023263 4.02443052,11.0983392 4.00375,12.4629 C2.14745543,10.8053783 1.50705045,8.1739974 2.39406906,5.84882952 C3.28108767,3.52366164 5.51138439,1.98741277 8,1.98741277 C10.4886156,1.98741277 12.7189123,3.52366164 13.6059309,5.84882952 C14.4929495,8.1739974 13.8525446,10.8053783 11.99625,12.4629 L11.99625,12.4629 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/icon_avatar.2fdf91b5.svg";
export { ForwardRef as ReactComponent };